import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import FormGroup from "@material-ui/core/FormGroup";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import moment from "moment-timezone";
import defaultFases from "../../constants/DefaultFases";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
// import { getGameResults } from "../../util/GetGameResults";

export default class ExportDialog extends React.Component {
  render() {
    let showIncludeResultsCheckbox = false;
    this.props.matches.forEach((m) => {
      const poule = this.props.poulesByKey[m.poule] || {};
      let scoreType =
        poule.scoreType ||
        (poule.bracket
          ? (this.props.bracketsByKey[poule.bracket] || {})["scoreType"]
          : false) ||
        ((this.props.tournament.scoringTypesPerDivisionPerPhase || {})[
          poule.division
        ] || {})[poule.fase] ||
        "default";
      let scoring =
        scoreType === "default"
          ? this.props.tournament
          : (this.props.tournament.scoringTypes || {})[scoreType] ||
            this.props.tournament;
      if ((scoring.useSets || "0") === "1" && (scoring.setsType || 0) === 0) {
        showIncludeResultsCheckbox = true;
      }
      if ((scoring.useSets || "0") === "0") {
        showIncludeResultsCheckbox = true;
      }
    });

    let showEventOption = false;
    Object.keys(this.props.tournament.breaks || {}).forEach((key) => {
      let b = this.props.tournament.breaks[key];
      if (b.isEvent) {
        showEventOption = true;
      }
    });
    let showResultsOption = true;
    // this.props.matches.forEach((match) => {
    //   let gameResults = getGameResults(this.props.tournament, match.sets || {});
    //   if (
    //     (match.score1 !== null && match.score2 !== null) ||
    //     gameResults.finished
    //   ) {
    //     showResultsOption = true;
    //   }
    // });
    let showPlayerNamesOption = (this.props.players || []).length > 0;
    let showCustomFieldsOption =
      Object.keys(this.props.tournament.infoFields || {}).length > 0;

    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.export === "schedule"
            ? languages.export.exportMatchSchedule
            : languages.export.exportMatchCards}
        </DialogTitle>
        <DialogContent
          style={{
            width: 350,
            maxWidth: "97%",
            paddingTop: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* {Object.keys(this.props.matchesPerDay).length > 1 && (
            <FormControl component="fieldset">
              <FormLabel component="legend">{languages.export.days}</FormLabel>
              <FormGroup style={{ flexDirection: "row" }}>
                {Object.keys(this.props.matchesPerDay).map((key, i) => {
                  return (
                    <FormControlLabel
                      key={key}
                      control={
                        <Checkbox
                          checked={this.props.days.indexOf(key) !== -1}
                          onChange={e => {
                            this.props.handleSelectChange(key, "days");
                          }}
                        />
                      }
                      label={
                        key === "0"
                          ? moment
                              .unix(this.props.tournament.date)
                              .format(languages.createTournament.dateFormat)
                          : moment
                              .unix(
                                (this.props.daysByKey[key] || {}).date || ""
                              )
                              .format(languages.createTournament.dateFormat)
                      }
                    />
                  );
                })}
              </FormGroup>
            </FormControl>
          )} */}
          {this.props.export === "schedule" && (
            <FormControl component="fieldset">
              <FormLabel component="legend">
                {languages.export.fileType}
              </FormLabel>
              <RadioGroup
                name="format"
                value={this.props.fileType}
                onChange={this.props.handleFileTypeChange}
                style={{ flexDirection: "row" }}
              >
                <FormControlLabel
                  value="pdf"
                  control={<Radio />}
                  label={languages.export.pdf}
                />
                <FormControlLabel
                  value="excel"
                  control={<Radio />}
                  label={languages.export.excel}
                />
              </RadioGroup>
            </FormControl>
          )}
          {((Object.keys(this.props.matchesPerDay).length > 1 &&
            !this.props.tournament.online) ||
            (this.props.tournament.online &&
              Object.keys(this.props.daysByKey).length > 0)) && (
            <FormControl
              style={{ width: "100%", marginBottom: 15, marginTop: 15 }}
            >
              <InputLabel htmlFor="selectedDay" style={{ fontSize: 20 }}>
                {languages.export.days}
              </InputLabel>
              <Select
                value={this.props.selectedDay}
                onChange={this.props.handleLocationChange}
                inputProps={{
                  name: "selectedDay",
                  id: "selectedDay",
                }}
              >
                <MenuItem value="all">
                  <em>{languages.export.allDays}</em>
                </MenuItem>

                {!this.props.tournament.online &&
                  Object.keys(this.props.matchesPerDay)
                    .sort((a, b) => {
                      let dateA = 0;
                      let dateB = 0;
                      if (a === "0") {
                        dateA = this.props.tournament.date;
                      } else {
                        dateA = (this.props.daysByKey[a] || {}).date || 0;
                      }
                      if (b === "0") {
                        dateB = this.props.tournament.date;
                      } else {
                        dateB = (this.props.daysByKey[b] || {}).date || 0;
                      }
                      return dateA - dateB;
                    })
                    .map((key, i) => {
                      return (
                        <MenuItem key={key} value={key}>
                          {key === "0"
                            ? moment
                                .unix(this.props.tournament.date)
                                .tz(
                                  this.props.tournament.timezone ||
                                    "Europe/Amsterdam"
                                )
                                .format(languages.createTournament.dateFormat)
                            : moment
                                .unix(
                                  (this.props.daysByKey[key] || {}).date || ""
                                )
                                .tz(
                                  this.props.tournament.timezone ||
                                    "Europe/Amsterdam"
                                )
                                .format(languages.createTournament.dateFormat)}
                        </MenuItem>
                      );
                    })}
                {this.props.tournament.online && (
                  <MenuItem value={"0"}>
                    {moment
                      .unix(this.props.tournament.date)
                      .tz(this.props.tournament.timezone || "Europe/Amsterdam")
                      .format(languages.createTournament.dateFormat)}
                  </MenuItem>
                )}
                {this.props.tournament.online &&
                  Object.keys(this.props.daysByKey).map((key, i) => {
                    return (
                      <MenuItem key={key} value={key}>
                        {moment
                          .unix((this.props.daysByKey[key] || {}).date || "")
                          .tz(
                            this.props.tournament.timezone || "Europe/Amsterdam"
                          )
                          .format(languages.createTournament.dateFormat)}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          )}
          {this.props.sportParks.length > 1 &&
            !this.props.tournament.online && (
              <FormControl
                style={{ width: "100%", marginBottom: 15, marginTop: 15 }}
              >
                <InputLabel htmlFor="selectedLocation" style={{ fontSize: 20 }}>
                  {languages.export.locations}
                </InputLabel>
                <Select
                  value={this.props.selectedLocation}
                  onChange={this.props.handleLocationChange}
                  inputProps={{
                    name: "selectedLocation",
                    id: "selectedLocation",
                  }}
                >
                  <MenuItem value="all">
                    <em>{languages.export.allLocations}</em>
                  </MenuItem>
                  {this.props.sportParksByKey["0"] === undefined && (
                    <MenuItem value={"0"}>
                      {languages.schedule.sportPark + " 1"}
                    </MenuItem>
                  )}
                  {this.props.sportParks.map((sportPark) => {
                    return (
                      <MenuItem key={sportPark.id} value={sportPark.id}>
                        {sportPark.name || languages.schedule.sportPark + " 1"}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}

          <FormControl component="fieldset" style={{ marginTop: 15 }}>
            <FormLabel component="legend">{languages.export.phases}</FormLabel>
            <div
              onClick={() => {
                this.props.selectAllPhases();
              }}
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                marginTop: 10,
              }}
            >
              {languages.export.selectAll}
            </div>
            <FormGroup>
              {Object.keys(this.props.divisionsObject).map((key, i) => {
                let divisionName = this.props.divisionsObject[key].name;
                let fases =
                  this.props.divisionsObject[key].fases || defaultFases;

                return (
                  <div key={key}>
                    {Object.keys(fases).map((faseKey, i) => {
                      let label = fases[faseKey].name;
                      if (Object.keys(this.props.divisionsObject).length > 1) {
                        label = label + " - " + divisionName;
                      }
                      let showFase = false;
                      if (this.props.selectedLocation === "all") {
                        showFase = true;
                      } else {
                        let poules = this.props.poules
                          .filter(
                            (p) =>
                              p.fase.toString() === faseKey &&
                              p.division === key
                          )
                          .map((p) => p.id);
                        let matches = this.props.matches.filter(
                          (m) => poules.indexOf(m.poule) !== -1
                        );
                        let matchInSportPark = false;
                        for (let i = 0; i < matches.length; i++) {
                          let m = matches[i];
                          let fields = this.props.tournament.fields || {};
                          let field = fields[m.field];
                          if (field) {
                            let sportPark = field.sportPark || "0";
                            if (this.props.selectedLocation === sportPark) {
                              matchInSportPark = true;
                              break;
                            }
                          }
                        }
                        if (matchInSportPark) {
                          showFase = true;
                        }
                      }
                      if (showFase) {
                        return (
                          <FormControlLabel
                            key={faseKey}
                            control={
                              <Checkbox
                                checked={
                                  (this.props.fases[key] || []).indexOf(
                                    faseKey
                                  ) !== -1
                                }
                                onChange={(e) => {
                                  this.props.handleFasesChange(key, faseKey);
                                }}
                              />
                            }
                            label={label}
                          />
                        );
                      } else {
                        return null;
                      }
                    })}
                  </div>
                );
              })}
            </FormGroup>
          </FormControl>

          <FormControl component="fieldset" style={{ marginTop: 15 }}>
            <FormLabel component="legend">{languages.export.sort}</FormLabel>
            <RadioGroup
              name="format"
              value={this.props.sort}
              onChange={this.props.handleSortChange}
            >
              <FormControlLabel
                value="time"
                control={<Radio />}
                label={
                  this.props.tournament.online
                    ? languages.schedule.round +
                      " -> " +
                      languages.structure.poule
                    : languages.export.sortTime
                }
              />
              {!this.props.tournament.online && (
                <FormControlLabel
                  value="field"
                  control={<Radio />}
                  label={languages.export.sortField}
                />
              )}
              {this.props.export !== "schedule" &&
                !this.props.tournament.online && (
                  <FormControlLabel
                    value="referee"
                    control={<Radio />}
                    label={languages.export.sortReferee}
                  />
                )}
              {this.props.export === "schedule" && (
                <FormControlLabel
                  value="poule"
                  control={<Radio />}
                  label={languages.export.sortPoule}
                />
              )}
              {this.props.export === "schedule" && (
                <FormControlLabel
                  value="team"
                  control={<Radio />}
                  label={languages.formatString(
                    languages.export.sortTeam,
                    this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow
                  )}
                />
              )}
            </RadioGroup>
          </FormControl>

          {this.props.export === "schedule" &&
            showEventOption &&
            this.props.sort !== "poule" &&
            !this.props.tournament.online && (
              <FormControlLabel
                style={{ marginTop: 10 }}
                control={
                  <Checkbox
                    checked={this.props.includeEvents}
                    onChange={this.props.handleIncludeEventsChange}
                  />
                }
                label={languages.export.includeEvents}
              />
            )}
          {this.props.export === "schedule" &&
            showResultsOption &&
            (this.props.fileType === "excel" ||
              (this.props.fileType === "pdf" &&
                showIncludeResultsCheckbox)) && (
              <FormControlLabel
                style={{ marginTop: 10 }}
                control={
                  <Checkbox
                    checked={this.props.includeResults}
                    onChange={this.props.handleIncludeResultsChange}
                  />
                }
                label={languages.export.includeResults}
              />
            )}
          {this.props.export === "schedule" &&
            this.props.fileType === "excel" &&
            showPlayerNamesOption && (
              <FormControlLabel
                style={{ marginTop: 10 }}
                control={
                  <Checkbox
                    checked={this.props.includePlayerNames}
                    onChange={this.props.handleIncludePlayerNamesChange}
                  />
                }
                label={languages.export.includePlayerNames}
              />
            )}
          {this.props.export === "schedule" &&
            this.props.fileType === "excel" &&
            showCustomFieldsOption && (
              <FormControlLabel
                style={{ marginTop: 10 }}
                control={
                  <Checkbox
                    checked={this.props.includeCustomFields}
                    onChange={this.props.handleIncludeCustomFieldsChange}
                  />
                }
                label={languages.formatString(
                  languages.export.includeCustomDataColumns,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
              />
            )}
          {this.props.export !== "schedule" && (
            <FormControl component="fieldset">
              <FormLabel component="legend">
                {languages.export.format}
              </FormLabel>
              <RadioGroup
                name="format"
                value={this.props.format}
                onChange={this.props.handleFormatChange}
                style={{ flexDirection: "row" }}
              >
                <FormControlLabel
                  value="multiple"
                  control={<Radio />}
                  label={languages.export.matchCardsMultiple}
                />
                <FormControlLabel
                  value="single"
                  control={<Radio />}
                  label={languages.export.matchCardsSingle}
                />
              </RadioGroup>
            </FormControl>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.props.handleClose}
            variant="text"
            color="default"
          >
            {languages.export.close}
          </Button>
          <Button
            onClick={
              this.props.fileType === "pdf" || this.props.export !== "schedule"
                ? this.props.handleMatchCardsExport
                : this.props.handleExcelExport
            }
            variant="contained"
            color="primary"
            type="submit"
            disabled={
              !this.props.atLeastOnePhaseSelected ||
              this.props.preparingExcelExport
            }
          >
            {languages.export.export}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
